import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function AbracadabarOpen() {
  const dateTexts = ['1940年', '9月'];
  const title = 'アブラカダ・バー でマジシャンたちが失踪する';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/IMG_7124-1.jpg'
  const description = (
    <>
      {'マジシャンたちが集うラウンジ'}
      <a href='/abracadabar'>
        {'アブラカダ・バー'}
      </a>
      {'で、一晩にしてマジシャンたちが失踪する。'}
      {'店内にはS.E.A.メンバーであることを象徴するトルコ帽子が置かれており、消えたマジシャンたちの中に持ち主がいたとも考えられるが、誰のものかはわかっていない。'}
    </>
  );
  const quoteDomain = 'disneyworld.disney.go.com';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default AbracadabarOpen;
